module.exports = __webpack_public_path__ + "static/img/gc_neck.1b5424e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/giftc/gc_neck.png
// module id = 306
// module chunks = 1